export default __webpack_public_path__ + "../pdf/Fプレミアム約款.pdf";